import { DashboardLayout } from "@/components";
import { authMiddleware } from "@/middleware";
import { SellerDetails } from "@/pages/relations/BuyerDetails";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_market/relations/sellers/$relationId")({
	component: SellerDetailsRoute,
	loader: authMiddleware,
});

function SellerDetailsRoute() {
	const { relationId } = Route.useParams();

	return (
		<DashboardLayout>
			<SellerDetails relationId={relationId} />
		</DashboardLayout>
	);
}
